import { render, staticRenderFns } from "./govjoke.vue?vue&type=template&id=60cc4fea&scoped=true"
import script from "./govjoke.vue?vue&type=script&lang=js"
export * from "./govjoke.vue?vue&type=script&lang=js"
import style0 from "./govjoke.vue?vue&type=style&index=0&id=60cc4fea&prod&scoped=true&lang=css"
import style1 from "./govjoke.vue?vue&type=style&index=1&id=60cc4fea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc4fea",
  null
  
)

export default component.exports